const brokerChargesMapper = (res) => {
    let brokerageEntity = null;
    if (res) {
        brokerageEntity = {
            brokerage: res.brokerage,
            clearingCharge: res.clearingCharge,
            gst: res.gst,
            sebiTurnoverCharge: res.sebiTurnoverCharge,
            stampDutyCharge: res.stampDutyCharge,
            stt: res.stt,
            totalCharge: res.totalCharge,
            transactionCharge: res.transactionCharge,
            turnover: res.turnover,
        };
        return brokerageEntity;
    }
    return {};
};
export default brokerChargesMapper;
